export default {
  title: "Untitled",
  thumbnail: null,
  workflow_info: null,
  runningAlgorithmNodes: [],  // Array of algorithm node IDs that are currently running
  taskAlgorithmMapping: {},   // Mapping of task_id to algorithm_id
};
